import React from 'react';
import './Tags.scss'; // Assuming your styles are in App.css

function Tags(props) {

  const {tags} = props;

  return (
    <div className="tag-container">
      {tags.map((tag, index) => (
        <div key={index} className="tag">
          {tag}
        </div>
      ))}
    </div>
  );
}

export default Tags;
